var _defs, _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _path8, _path9, _path10, _circle, _circle2, _circle3, _path11, _path12, _path13, _path14, _path15, _circle4, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g, _path26, _path27, _path28;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoAudios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "undraw_add_post_re_174w_1_",
    "data-name": "undraw_add_post_re_174w(1)",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 412.61,
    height: 262.96,
    viewBox: "0 0 412.61 262.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.944,
    x2: 0,
    y2: 0.046,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#951eff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03bca2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.164,
    x2: 0.779,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9520ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ab5a6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01bea1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#941efd"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M398.913,680.872l-12.632,7.335,12.453-3.006c-.1,1.028-.227,2.039-.4,3.027-.048.274-.1.544-.157.815a22.6,22.6,0,0,1-2.287,6.5c-.209.375-.418.74-.636,1.093s-.427.7-.649,1.037H361.121c-.279-.335-.544-.684-.788-1.037a15.67,15.67,0,0,1-2.692-11.6,19.592,19.592,0,0,1,.523-2.452,22.472,22.472,0,0,1,.8-2.426,31.99,31.99,0,0,1,1.921-4.073,25.746,25.746,0,0,1,6.743-7.466,47.063,47.063,0,0,1,4.26-2.962q.418-.268.849-.523c.44-.261.88-.518,1.324-.767.884-.505,1.777-.984,2.67-1.437.235-.122.466-.24.7-.353,1.938-.967,3.868-1.834,5.706-2.6.231-.1.466-.192.7-.283a101.627,101.627,0,0,1,11.2-3.838s.013.035.035.109c.057.2.2.684.4,1.4.544,1.982,1.5,5.763,2.274,10.328.044.248.083.5.126.754a79.14,79.14,0,0,1,1.067,11.678c0,.244,0,.484,0,.727Z",
    transform: "translate(-256.789 -434.713)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M419.913,654.63c0,.013-.048.227-.148.619-.083.327-.2.775-.344,1.333-.51,1.947-1.416,5.21-2.705,9.139-.074.227-.152.462-.231.7-.9,2.688-1.965,5.658-3.2,8.712-.309.767-.619,1.52-.937,2.256-.1.231-.192.457-.292.68q-2.026,4.691-4.168,8.585l-.362.649a58.594,58.594,0,0,1-5.745,8.546c-.292.357-.588.7-.889,1.037h-1.011c.3-.335.61-.684.906-1.037a57.561,57.561,0,0,0,6.042-8.886c.122-.213.244-.427.362-.645,1.538-2.792,2.936-5.711,4.186-8.6.1-.222.2-.449.292-.68,1.633-3.824,3.006-7.584,4.112-10.894.078-.235.157-.47.231-.7,1.612-4.887,2.622-8.72,3.01-10.254.052-.227.1-.405.126-.527s.043-.179.048-.192l.353.083h0Z",
    transform: "translate(-280.747 -433.923)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M431.488,672.435c-.222-.013-.444-.035-.666-.057a19.6,19.6,0,0,1-4.979-1.189c-.231-.091-.466-.183-.7-.283a19.978,19.978,0,0,1-1.864-.919,19.722,19.722,0,0,1-6.364-5.606c-.057-.074-.113-.152-.165-.227q-.34.144-.693.287c.052.074.1.148.161.222a20.371,20.371,0,0,0,6.7,5.968,21.041,21.041,0,0,0,1.991.976c.231.1.466.192.7.279a20.426,20.426,0,0,0,5.336,1.246c.218.022.44.039.658.052C431.566,672.928,431.527,672.679,431.488,672.435Z",
    transform: "translate(-289.874 -439.392)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M423.888,688.541a19.763,19.763,0,0,1-10.537-1.956q-.346-.163-.68-.353a1.843,1.843,0,0,1-.2-.109,19.854,19.854,0,0,1-10.084-15.132c-.009-.074-.017-.152-.026-.227-.235.122-.47.24-.7.362.009.074.017.144.03.218a20.571,20.571,0,0,0,10.424,15.424c.087.048.178.1.27.144q.34.183.68.353a20.5,20.5,0,0,0,10.811,2.017c.2-.017.392-.039.588-.061,0-.248,0-.492,0-.741C424.271,688.5,424.079,688.524,423.888,688.541Z",
    transform: "translate(-281.747 -443.123)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M416.629,699.975a19.841,19.841,0,0,1-12.088.091,19.365,19.365,0,0,1-2.313-.88c-.235-.1-.466-.218-.7-.335-.248-.122-.492-.253-.732-.383A19.9,19.9,0,0,1,390.612,680a19.059,19.059,0,0,1,.418-3.119c.013-.07.026-.139.044-.209-.288.179-.575.357-.858.54-.013.065-.026.126-.035.192a20.375,20.375,0,0,0-.318,4.264,20.583,20.583,0,0,0,10.576,17.437c.244.135.488.266.732.388s.466.231.7.34a20.549,20.549,0,0,0,14.605.954c.161-.044.322-.1.484-.148.065-.279.122-.558.174-.836C416.965,699.866,416.8,699.922,416.629,699.975Z",
    transform: "translate(-275.085 -446.458)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 24.393,
    height: 24.393,
    transform: "translate(87.226 107.381)",
    fill: "#9e616a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M165.325,557.194h4.806l2.286-18.537h-7.093Z",
    transform: "translate(-93.311 -304.024)",
    fill: "#9e616a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M301.542,731.126l-7.222-4.988v-3.254l-.819.048-5.149.309-1.629.1-.928,11.125-.03.37h3.411l.07-.37.54-2.849,1.381,2.849.179.37h9.043a2.033,2.033,0,0,0,1.154-3.707Z",
    transform: "translate(-216.337 -472.54)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M229.853,551.125l4.619,1.328,7.321-17.183-6.817-1.961Z",
    transform: "translate(-129.732 -301.006)",
    fill: "#9e616a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M360.921,727.687l-5.562-6.791.9-3.128-.8-.179-4.465-1-.571-.126-1.59-.357-4.1,10.781,3.276.945,1.477-2.927.606,3.524,2.065.592,5.615,1.616,1.015.292a2.031,2.031,0,0,0,2.134-3.241Z",
    transform: "translate(-249.62 -468.713)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M738.63,148.155H484.049a1.429,1.429,0,0,0-1.424,1.429v8.385a1.429,1.429,0,0,0,1.424,1.429H738.633a1.429,1.429,0,0,0,1.424-1.429v-8.385a1.429,1.429,0,0,0-1.427-1.429Z",
    transform: "translate(-327.447 -148.155)",
    fill: "#e4e4e4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_90",
    "data-name": "Ellipse 90",
    cx: 2.025,
    cy: 2.025,
    r: 2.025,
    transform: "translate(161.429 3.187)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_91",
    "data-name": "Ellipse 91",
    cx: 2.025,
    cy: 2.025,
    r: 2.025,
    transform: "translate(169.113 3.187)",
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_92",
    "data-name": "Ellipse 92",
    cx: 2.025,
    cy: 2.025,
    r: 2.025,
    transform: "translate(176.798 3.187)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M1040.747,153.915H1031.9a.656.656,0,1,0,0,1.311h8.847a.656.656,0,1,0,0-1.311Z",
    transform: "translate(-637.095 -151.406)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M1040.747,159.555H1031.9a.656.656,0,1,0,0,1.311h8.847a.656.656,0,1,0,0-1.311Z",
    transform: "translate(-637.095 -154.589)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M1040.747,165.2H1031.9a.656.656,0,1,0,0,1.311h8.847a.656.656,0,1,0,0-1.311Z",
    transform: "translate(-637.095 -157.773)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M394.112,323.387a4.368,4.368,0,0,0-.184.761l-27.008-4.774-23.264-12.545a6.569,6.569,0,0,0-7.011,11.072h0a51.822,51.822,0,0,0,14.259,7.4l16.866,5.649,29.542-1.894a4.355,4.355,0,1,0-3.2-5.673Z",
    transform: "translate(-243.543 -237.268)",
    fill: "#9e616a"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M488.279,346.055H428.04a1.786,1.786,0,0,0-1.585,1.93v29.757a1.786,1.786,0,0,0,1.585,1.93h60.238a1.786,1.786,0,0,0,1.582-1.93V347.985A1.786,1.786,0,0,0,488.279,346.055Z",
    transform: "translate(-287.289 -260.095)",
    fill: "url(#linear-gradient)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 12.949,
    cy: 12.949,
    r: 12.949,
    transform: "translate(83.168 56.393) rotate(-61.337)",
    fill: "#9e616a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M335.522,229.675h-8.365c-5.484,0-9.93,5-9.93,11.171-4.138,4.155-2.9,9.36.387,14.964a65,65,0,0,1,17.224,4.607l.781-3.334,1.54,4.391q2.055,1,4.074,2.177c-1.572-7.384-2.218-14.75-1.139-20.473h2.833v-3.1l.962,3.1h5.136a13.5,13.5,0,0,0-13.5-13.5Z",
    transform: "translate(-232.614 -194.166)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M335.813,302.8l-15.662-.679-.421,1.6a93.071,93.071,0,0,0-1.568,40.322h0a3.59,3.59,0,0,1,1.021,3.488l-.225.9.021.033a5.254,5.254,0,0,1,.7,3.922h0l.783,4.313,25.371-11.209,5.663-19.6Z",
    transform: "translate(-233.777 -235.053)",
    fill: "#cacaca"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M383.112,349.541a4.368,4.368,0,0,0-.472.625l-22.87-15.14-16.339-20.775a6.569,6.569,0,0,0-10.842,7.361h0a51.82,51.82,0,0,0,10.129,12.471l13.218,11.9,27.85,10.034a4.355,4.355,0,1,0-.674-6.478Z",
    transform: "translate(-242.262 -240.486)",
    fill: "#9e616a"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M547.689,266.383a12.517,12.517,0,1,1,12.517-12.517,12.517,12.517,0,0,1-12.517,12.517Z",
    transform: "translate(-357.106 -200.755)",
    fill: "#e4e4e4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M560.848,260.851h-3.7v-3.7a1.235,1.235,0,1,0-2.469,0v3.7h-3.7a1.235,1.235,0,1,0,0,2.469h3.7v3.7a1.235,1.235,0,1,0,2.469,0v-3.7h3.7a1.235,1.235,0,1,0,0-2.469Z",
    transform: "translate(-365.325 -208.974)",
    fill: "url(#linear-gradient-2)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M345.836,508.459a7.35,7.35,0,0,0-.684-6.572l-11.072-57.433-4.356-21.779H303.588s-16.335,18.077-12.85,41.163l-.975,32.512a11.956,11.956,0,0,0-.655,7.05l.388,1.839-.15.277a9.293,9.293,0,0,0-.117,8.612l-1.1,36.826,7.841-.436,11.543-42.905,7.623-38.549,12.85,29.838.436,6.969-.211,6.143-10.025,35.891,8.494,3.267Z",
    transform: "translate(-217.669 -303.098)",
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M317.894,749.983a.52.52,0,0,1-.518.518H126.893a.518.518,0,1,1,0-1.037H317.376a.517.517,0,0,1,.518.518Z",
    transform: "translate(-126.375 -487.542)",
    fill: "#cacaca"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "graphic_eq_FILL0_wght400_GRAD0_opsz48",
    d: "M126.321-864.123a1.1,1.1,0,0,1-.692-.214.648.648,0,0,1-.276-.53v-10.419a.644.644,0,0,1,.281-.53,1.12,1.12,0,0,1,.7-.214,1.1,1.1,0,0,1,.692.214.648.648,0,0,1,.276.53v10.419a.644.644,0,0,1-.281.53A1.119,1.119,0,0,1,126.321-864.123Zm5.354,3.969a1.1,1.1,0,0,1-.692-.214.648.648,0,0,1-.276-.53v-18.357a.644.644,0,0,1,.281-.53,1.12,1.12,0,0,1,.7-.214,1.1,1.1,0,0,1,.692.214.648.648,0,0,1,.276.53V-860.9a.644.644,0,0,1-.281.53A1.119,1.119,0,0,1,131.675-860.154Zm-10.707-7.938a1.1,1.1,0,0,1-.692-.214.648.648,0,0,1-.276-.53v-2.481a.644.644,0,0,1,.281-.53,1.12,1.12,0,0,1,.7-.214,1.1,1.1,0,0,1,.692.214.648.648,0,0,1,.276.53v2.481a.644.644,0,0,1-.281.53A1.119,1.119,0,0,1,120.968-868.093Zm16.061,3.969a1.1,1.1,0,0,1-.692-.214.648.648,0,0,1-.276-.53v-10.419a.644.644,0,0,1,.281-.53,1.12,1.12,0,0,1,.7-.214,1.1,1.1,0,0,1,.692.214.648.648,0,0,1,.276.53v10.419a.644.644,0,0,1-.281.53A1.119,1.119,0,0,1,137.028-864.123Zm5.354-3.969a1.1,1.1,0,0,1-.692-.214.648.648,0,0,1-.276-.53v-2.481a.644.644,0,0,1,.281-.53,1.12,1.12,0,0,1,.7-.214,1.1,1.1,0,0,1,.692.214.648.648,0,0,1,.276.53v2.481a.644.644,0,0,1-.281.53A1.119,1.119,0,0,1,142.382-868.093Z",
    transform: "translate(27.362 972.846)",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "graphic_eq_FILL0_wght400_GRAD0_opsz48-2",
    "data-name": "graphic_eq_FILL0_wght400_GRAD0_opsz48",
    d: "M126.321-867.511a1.308,1.308,0,0,1-.692-.168.487.487,0,0,1-.276-.417v-8.2a.487.487,0,0,1,.281-.417,1.339,1.339,0,0,1,.7-.168,1.309,1.309,0,0,1,.692.168.487.487,0,0,1,.276.417v8.2a.486.486,0,0,1-.281.417A1.339,1.339,0,0,1,126.321-867.511Zm5.354,3.122a1.307,1.307,0,0,1-.692-.168.487.487,0,0,1-.276-.417v-14.44a.487.487,0,0,1,.281-.417,1.339,1.339,0,0,1,.7-.168,1.309,1.309,0,0,1,.692.168.487.487,0,0,1,.276.417v14.44a.486.486,0,0,1-.281.417A1.338,1.338,0,0,1,131.675-864.389Zm-10.707-6.245a1.308,1.308,0,0,1-.692-.168.487.487,0,0,1-.276-.417v-1.951a.487.487,0,0,1,.281-.417,1.339,1.339,0,0,1,.7-.168,1.309,1.309,0,0,1,.692.168.487.487,0,0,1,.276.417v1.951a.487.487,0,0,1-.281.417A1.339,1.339,0,0,1,120.968-870.633Zm16.061,3.122a1.308,1.308,0,0,1-.692-.168.487.487,0,0,1-.276-.417v-8.2a.487.487,0,0,1,.281-.417,1.339,1.339,0,0,1,.7-.168,1.309,1.309,0,0,1,.692.168.487.487,0,0,1,.276.417v8.2a.487.487,0,0,1-.281.417A1.339,1.339,0,0,1,137.028-867.511Zm5.354-3.122a1.308,1.308,0,0,1-.692-.168.487.487,0,0,1-.276-.417v-1.951a.487.487,0,0,1,.281-.417,1.339,1.339,0,0,1,.7-.168,1.308,1.308,0,0,1,.692.168.487.487,0,0,1,.276.417v1.951a.486.486,0,0,1-.281.417A1.339,1.339,0,0,1,142.382-870.633Z",
    transform: "translate(54.16 974.963)",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M488.278,346.055H428.04a1.526,1.526,0,0,0-1.585,1.453v22.405a1.526,1.526,0,0,0,1.585,1.453h60.238a1.525,1.525,0,0,0,1.582-1.453V347.508A1.525,1.525,0,0,0,488.278,346.055Z",
    transform: "translate(-178.15 -307.634)",
    fill: "#e4e4e4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174",
    transform: "translate(559.453 102.153) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "graphic_eq_FILL0_wght400_GRAD0_opsz48-3",
    "data-name": "graphic_eq_FILL0_wght400_GRAD0_opsz48",
    d: "M126.321-866.774a1.251,1.251,0,0,1-.692-.178.519.519,0,0,1-.276-.442v-8.68a.517.517,0,0,1,.281-.442,1.28,1.28,0,0,1,.7-.178,1.251,1.251,0,0,1,.692.178.519.519,0,0,1,.276.442v8.68a.517.517,0,0,1-.281.442A1.279,1.279,0,0,1,126.321-866.774Zm5.354,3.307a1.25,1.25,0,0,1-.692-.178.519.519,0,0,1-.276-.442V-879.38a.517.517,0,0,1,.281-.442,1.28,1.28,0,0,1,.7-.178,1.251,1.251,0,0,1,.692.178.519.519,0,0,1,.276.442v15.293a.517.517,0,0,1-.281.442A1.28,1.28,0,0,1,131.675-863.467Zm-10.707-6.613a1.25,1.25,0,0,1-.692-.178A.519.519,0,0,1,120-870.7v-2.067a.518.518,0,0,1,.281-.442,1.28,1.28,0,0,1,.7-.178,1.251,1.251,0,0,1,.692.178.519.519,0,0,1,.276.442v2.067a.517.517,0,0,1-.281.442A1.279,1.279,0,0,1,120.968-870.08Zm16.061,3.307a1.251,1.251,0,0,1-.692-.178.519.519,0,0,1-.276-.442v-8.68a.517.517,0,0,1,.281-.442,1.28,1.28,0,0,1,.7-.178,1.251,1.251,0,0,1,.692.178.519.519,0,0,1,.276.442v8.68a.517.517,0,0,1-.281.442A1.28,1.28,0,0,1,137.028-866.774Zm5.354-3.307a1.251,1.251,0,0,1-.692-.178.519.519,0,0,1-.276-.442v-2.067a.518.518,0,0,1,.281-.442,1.28,1.28,0,0,1,.7-.178,1.251,1.251,0,0,1,.692.178.519.519,0,0,1,.276.442v2.067a.517.517,0,0,1-.281.442A1.28,1.28,0,0,1,142.382-870.08Z",
    transform: "translate(134.646 922.81)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "graphic_eq_FILL0_wght400_GRAD0_opsz48-4",
    "data-name": "graphic_eq_FILL0_wght400_GRAD0_opsz48",
    d: "M126.321-870.161a1.594,1.594,0,0,1-.692-.133q-.276-.133-.276-.329v-6.457q0-.2.281-.329a1.634,1.634,0,0,1,.7-.133,1.6,1.6,0,0,1,.692.133q.276.133.276.329v6.457q0,.2-.281.329A1.633,1.633,0,0,1,126.321-870.161Zm5.354,2.46a1.593,1.593,0,0,1-.692-.133q-.276-.133-.276-.329v-11.376q0-.2.281-.329a1.634,1.634,0,0,1,.7-.133,1.6,1.6,0,0,1,.692.133q.276.133.276.329v11.376q0,.2-.281.329A1.632,1.632,0,0,1,131.675-867.7Zm-10.707-4.919a1.594,1.594,0,0,1-.692-.133q-.276-.133-.276-.329v-1.537q0-.2.281-.329a1.634,1.634,0,0,1,.7-.133,1.6,1.6,0,0,1,.692.133q.276.133.276.329v1.537q0,.2-.281.329A1.633,1.633,0,0,1,120.968-872.621Zm16.061,2.46a1.594,1.594,0,0,1-.692-.133q-.276-.133-.276-.329v-6.457q0-.2.281-.329a1.634,1.634,0,0,1,.7-.133,1.6,1.6,0,0,1,.692.133q.276.133.276.329v6.457q0,.2-.281.329A1.633,1.633,0,0,1,137.028-870.161Zm5.354-2.46a1.594,1.594,0,0,1-.692-.133q-.276-.133-.276-.329v-1.537q0-.2.281-.329a1.634,1.634,0,0,1,.7-.133,1.6,1.6,0,0,1,.692.133q.276.133.276.329v1.537q0,.2-.281.329A1.633,1.633,0,0,1,142.382-872.621Z",
    transform: "translate(161.445 924.927)",
    fill: "url(#linear-gradient-3)"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M488.278,346.055H428.04a1.526,1.526,0,0,0-1.585,1.453v22.405a1.526,1.526,0,0,0,1.585,1.453h60.238a1.525,1.525,0,0,0,1.582-1.453V347.508A1.525,1.525,0,0,0,488.278,346.055Z",
    transform: "translate(-95.711 -307.634)",
    fill: "#e4e4e4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "graphic_eq_FILL0_wght400_GRAD0_opsz48-5",
    "data-name": "graphic_eq_FILL0_wght400_GRAD0_opsz48",
    d: "M126.321-866.774a1.251,1.251,0,0,1-.692-.178.519.519,0,0,1-.276-.442v-8.68a.517.517,0,0,1,.281-.442,1.28,1.28,0,0,1,.7-.178,1.251,1.251,0,0,1,.692.178.519.519,0,0,1,.276.442v8.68a.517.517,0,0,1-.281.442A1.279,1.279,0,0,1,126.321-866.774Zm5.354,3.307a1.25,1.25,0,0,1-.692-.178.519.519,0,0,1-.276-.442V-879.38a.517.517,0,0,1,.281-.442,1.28,1.28,0,0,1,.7-.178,1.251,1.251,0,0,1,.692.178.519.519,0,0,1,.276.442v15.293a.517.517,0,0,1-.281.442A1.28,1.28,0,0,1,131.675-863.467Zm-10.707-6.613a1.25,1.25,0,0,1-.692-.178A.519.519,0,0,1,120-870.7v-2.067a.518.518,0,0,1,.281-.442,1.28,1.28,0,0,1,.7-.178,1.251,1.251,0,0,1,.692.178.519.519,0,0,1,.276.442v2.067a.517.517,0,0,1-.281.442A1.279,1.279,0,0,1,120.968-870.08Zm16.061,3.307a1.251,1.251,0,0,1-.692-.178.519.519,0,0,1-.276-.442v-8.68a.517.517,0,0,1,.281-.442,1.28,1.28,0,0,1,.7-.178,1.251,1.251,0,0,1,.692.178.519.519,0,0,1,.276.442v8.68a.517.517,0,0,1-.281.442A1.28,1.28,0,0,1,137.028-866.774Zm5.354-3.307a1.251,1.251,0,0,1-.692-.178.519.519,0,0,1-.276-.442v-2.067a.518.518,0,0,1,.281-.442,1.28,1.28,0,0,1,.7-.178,1.251,1.251,0,0,1,.692.178.519.519,0,0,1,.276.442v2.067a.517.517,0,0,1-.281.442A1.28,1.28,0,0,1,142.382-870.08Z",
    transform: "translate(217.085 922.81)",
    fill: "url(#linear-gradient-3)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "graphic_eq_FILL0_wght400_GRAD0_opsz48-6",
    "data-name": "graphic_eq_FILL0_wght400_GRAD0_opsz48",
    d: "M126.321-870.161a1.594,1.594,0,0,1-.692-.133q-.276-.133-.276-.329v-6.457q0-.2.281-.329a1.634,1.634,0,0,1,.7-.133,1.6,1.6,0,0,1,.692.133q.276.133.276.329v6.457q0,.2-.281.329A1.633,1.633,0,0,1,126.321-870.161Zm5.354,2.46a1.593,1.593,0,0,1-.692-.133q-.276-.133-.276-.329v-11.376q0-.2.281-.329a1.634,1.634,0,0,1,.7-.133,1.6,1.6,0,0,1,.692.133q.276.133.276.329v11.376q0,.2-.281.329A1.632,1.632,0,0,1,131.675-867.7Zm-10.707-4.919a1.594,1.594,0,0,1-.692-.133q-.276-.133-.276-.329v-1.537q0-.2.281-.329a1.634,1.634,0,0,1,.7-.133,1.6,1.6,0,0,1,.692.133q.276.133.276.329v1.537q0,.2-.281.329A1.633,1.633,0,0,1,120.968-872.621Zm16.061,2.46a1.594,1.594,0,0,1-.692-.133q-.276-.133-.276-.329v-6.457q0-.2.281-.329a1.634,1.634,0,0,1,.7-.133,1.6,1.6,0,0,1,.692.133q.276.133.276.329v6.457q0,.2-.281.329A1.633,1.633,0,0,1,137.028-870.161Zm5.354-2.46a1.594,1.594,0,0,1-.692-.133q-.276-.133-.276-.329v-1.537q0-.2.281-.329a1.634,1.634,0,0,1,.7-.133,1.6,1.6,0,0,1,.692.133q.276.133.276.329v1.537q0,.2-.281.329A1.633,1.633,0,0,1,142.382-872.621Z",
    transform: "translate(243.884 924.927)",
    fill: "url(#linear-gradient-3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAudios);
export default __webpack_public_path__ + "static/media/NoAudios.20007da8aa761bdc3c03bf11f913b6ea.svg";
export { ForwardRef as ReactComponent };